import axios from "axios";

const http = axios.create({
    baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
    headers: {
        "Content-Type": "application/json; charset=utf-8; x-api-version=2.0",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT",
    }
});
http.interceptors.request.use(
    (config: any) => {
        const token = localStorage.getItem('Token');
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

// Response interceptor for better error handling
http.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
      return Promise.reject(error);
    }
);

export { http };